<template>
  <div class="rounded-lg border border-gray-200 overflow-hidden bg-white">
    <div class="flex justify-between items-center p-6">
      <h2 class="text-lg font-semibold text-gray-900">Products</h2>
      <Button v-if="props.canEdit" @click="onShowProductModal()" variant="outline">
        <Plus class="h-4 w-4" />
        Add Product
      </Button>
    </div>
    <div class="border-t border-gray-200">
      <table v-if="order?.products" class="w-full table-auto text-sm text-left">
        <thead class="bg-grey-light-100 text-grey-light-600 font-medium border-b border-gray-200">
          <tr>
            <th class="px-4 py-2">Description</th>
            <th class="px-4 py-2">SKU</th>
            <th class="px-4 py-2 text-right">Amount</th>
            <th class="px-4 py-2">Product Link</th>
          </tr>
        </thead>
        <tbody class="text-grey-light-600">
          <tr v-for="product in order.products" :key="product._id" class="border-b border-gray-200">
            <td
              @click="canEdit ? onShowProductModal(product) : ''"
              class="p-5 flex items-center gap-2 hover:cursor-pointer"
            >
              {{ product.name ? product.name : order.name }}
              <SquarePen v-if="canEdit" class="w-4 h-4" />
            </td>
            <td class="p-5">
              {{ product.sku }}
            </td>
            <td class="p-5 text-right">
              {{ (product.sku && product.sku.includes('cancelled')) || (product.amount || 0) < 0 ? '-' : '' }}
              {{ currency(product.amount || 0) }}
            </td>
            <td class="p-5">
              {{ product.link ? product.link : 'N/A' }}
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else class="p-6 text-gray-500">
        <p>No products available.</p>
      </div>
    </div>
    <ProductModal
      :order-id="order?._id!"
      :show="showProductModal"
      :selected-product="selectedProduct"
      @update:show="showProductModal = false"
    />
  </div>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { currency } from '@/utils/format.utils';
import { Plus, SquarePen } from 'lucide-vue-next';
import { ref } from 'vue';
import type { ModelOrderResponse, ModelProductResponse } from '@layup/api-sdk';
import ProductModal from '../ProductModal.vue';

const props = defineProps<{
  canEdit: boolean;
  order: ModelOrderResponse | null | undefined;
}>();

const showProductModal = ref(false);
const selectedProduct = ref<ModelProductResponse>();

const onShowProductModal = (product?: ModelProductResponse) => {
  selectedProduct.value = product || undefined;
  showProductModal.value = true;
};
</script>
